import { postEventSongNoteGuest } from "../../../../helpers/event_helper.js";
import { eventSongNoteSaving, eventSongNoteSuccess, eventSongNoteError } from "./reducer";

// guestNote: a trimmed string, or null to clear the dedication.
export const updateEventSongNote = (id, guestId, guestNote) => async (dispatch) => {
  try {
    dispatch(eventSongNoteSaving());
    const data = await postEventSongNoteGuest(id, { id: guestId, guestNote });
    if (data) {
      dispatch(eventSongNoteSuccess());
    }
  } catch (error) {
    // 422 validation errors arrive as a violations array, everything else as a string.
    const message = Array.isArray(error) ? error[0]?.message : error;
    dispatch(eventSongNoteError(message));
  }
};
